import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=704c48e0&scoped=true"
import script from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=704c48e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c48e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704c48e0')) {
      api.createRecord('704c48e0', component.options)
    } else {
      api.reload('704c48e0', component.options)
    }
    module.hot.accept("./ChatBot.vue?vue&type=template&id=704c48e0&scoped=true", function () {
      api.rerender('704c48e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/communication/bot/components/ChatBot.vue"
export default component.exports